export default "__VITE_ASSET__$svtEDb___"